import Header, { HeaderWithCustomContent } from '@amzn/awsscm-argo-core/argo/ui/header';
import { ChatButton } from '@amzn/awsscmui-argo-chatbot-component';
import { isExternalArgoUser } from 'rfxportal/RFX/userPermissionHelper';

import '@amzn/awsscmui-argo-chatbot-component/argo/index.css';

interface RFXHeaderProps {
  isChatConentVisible: boolean;
  setIsChatContentVisible: (visible: boolean) => void;
}

/**
 * Provides the basic layout for all types of pages, including collapsible side navigation, tools panel, and split panel.
 */
export function RFXHeader({ isChatConentVisible, setIsChatContentVisible }: RFXHeaderProps) {
  if (isExternalArgoUser() || isChatConentVisible) {
    return <Header />;
  }

  return (
    <HeaderWithCustomContent
      customContent={<ChatButton showInHeader={true} onClick={() => setIsChatContentVisible(true)} />}
      customContentAlignment="right"
    />
  );
}
